import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../store/global-selectors';
import FulfillmentServiceDropdown from './index';
import { EXTERNAL_SHIP_FROM_PREFIX } from '../../store/csw/csw.fulfillment-plan-to-csw';

const BulkExternalFulfillmentServiceDropdownContainer = ({ className = '', model, onChange, sellerFulfillmentProviderId }) => {
  const shapedSellerFulfillmentProviderId = useMemo(() => {
    return sellerFulfillmentProviderId.includes(EXTERNAL_SHIP_FROM_PREFIX)
      ? sellerFulfillmentProviderId.split(EXTERNAL_SHIP_FROM_PREFIX)[1]
      : sellerFulfillmentProviderId;
  }, [sellerFulfillmentProviderId]);

  const fulfillmentServices =
    useSelector((state) =>
      Global.selectSellerFulfillmentServicesBySellerFulfillmentProviderId(state, {
        sellerFulfillmentProviderId: shapedSellerFulfillmentProviderId,
      }),
    ) || emptyArray;
  const shapedFulfillmentServices = fulfillmentServices.map(({ fulfillmentServiceId, name }) => ({ name, id: fulfillmentServiceId }));
  const onChangeCB = useCallback(
    (fulfillmentServiceId) => {
      onChange({
        ...model,
        externalFulfillmentConfiguration: {
          ...model?.externalFulfillmentConfiguration,
          sellerFulfillmentProviderId,
          fulfillmentServiceId,
        },
      });
    },
    [onChange, model, sellerFulfillmentProviderId],
  );

  return (
    <FulfillmentServiceDropdown
      className={className}
      fulfillmentServices={shapedFulfillmentServices}
      onChange={onChangeCB}
      selectedFulfillmentServiceId={model?.externalFulfillmentConfiguration?.fulfillmentServiceId}
    />
  );
};

BulkExternalFulfillmentServiceDropdownContainer.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({
    externalFulfillmentConfiguration: PropTypes.shape({
      sellerFulfillmentProviderId: PropTypes.string,
      fulfillmentServiceId: PropTypes.string,
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  sellerFulfillmentProviderId: PropTypes.string.isRequired,
};

export default BulkExternalFulfillmentServiceDropdownContainer;
